import { RGB } from 'pdf-lib';

export type Color = Omit<RGB, 'type'>;

export enum Font {
  MulishRegular = 'Mulish-Regular',
  MulishBold = 'Mulish-Bold',
}

export interface WatermarkConfig {
  font?: Font;
  fontColor?: Color;
  fontSize?: number;
  /* Height in pixels that can be used instead of fontSize */
  fontHeight?: number;
  /* Opacity of watermark from 0 to 1 */
  fontOpacity?: number;
  rotationAngle?: number;
  /* Separator that divides passed items of text array */
  textSeparator?: string;
  /* Distance in pixels between lines */
  lineGap?: number;
}

export interface FileConfig {
  customFileName?: string;
}
